export default {
  data() {
    return { year: new Date().getFullYear() };
  },
  on: {
    pageInit() {
      const toggle = document.getElementById('togglePassword');
      const pwInput = document.getElementById('password');
      if (toggle && pwInput) {
        toggle.addEventListener('click', () => {
          const isPassword = pwInput.type === 'password';
          pwInput.type = isPassword ? 'text' : 'password';
          toggle.querySelector('i').textContent = isPassword ? 'eye_slash' : 'eye';
        });
      }
    }
  },
  id: '9623ece7b3',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page lp" data-name="login">\n    <div class="page-content lp__content">\n\n      <div class="lp__bg-grid" aria-hidden="true"></div>\n      <div class="lp__bg-glow" aria-hidden="true"></div>\n      <div class="lp__bg-glow2" aria-hidden="true"></div>\n\n      <!-- \u2500\u2500 Brand Header \u2500\u2500 -->\n      <header class="lp__header">\n        <div class="lp__logo-halo"></div>\n        <img src="assets/icons/icon_wide.png" alt="DigiMExpress" class="lp__logo">\n        <!-- <p class="lp__brand-name">DIGI MONEY EXPRESS</p> -->\n        <div class="lp__brand-rule">\n          <span></span><span class="lp__brand-diamond">\u25C6</span><span></span>\n        </div>\n        <p class="lp__brand-tag">PREMIUM INVESTMENT PLATFORM</p>\n      </header>\n\n      <!-- \u2500\u2500 Form Card \u2500\u2500 -->\n      <div class="lp__card">\n        <div class="lp__card-accent"></div>\n\n        <div class="lp__card-body">\n          <div class="lp__card-heading">\n            <h1 class="lp__title">Secure Sign In</h1>\n            <p class="lp__subtitle">Access your investment portfolio</p>\n          </div>\n\n          <form name="userLogin" id="userLogin" action="" method="POST">\n\n            <!-- Email / Username Field -->\n            <div class="lp__field item-input">\n              <label class="lp__label" for="username">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>\n                Email or Username\n              </label>\n              <div class="lp__input-row">\n                <input type="text" name="username" id="username"\n                  placeholder="Enter your email or username"\n                  maxlength="100" minlength="3"\n                  required class="lp__input" style="padding-left:14px;"\n                  validate\n                  data-error-message="Enter your email or username" />\n              </div>\n              <div class="item-input-error-message">Enter your email or username</div>\n            </div>\n\n            <!-- \u2500\u2500 Mobile Number login (kept for future use) \u2500\u2500\n            <div class="lp__field item-input">\n              <label class="lp__label" for="username">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 1.27h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.77a16 16 0 0 0 6.29 6.29l.88-.88a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/></svg>\n                Mobile Number\n              </label>\n              <div class="lp__phone-row">\n                <input type="hidden" name="countryCode" id="selectedDialCode" value="IN" />\n                <input type="tel" name="username" id="username"\n                  placeholder="Enter mobile number"\n                  maxlength="15" minlength="10"\n                  required class="lp__input lp__iti-input"\n                  validate\n                  data-error-message="Enter your mobile number" />\n              </div>\n              <div class="item-input-error-message">Enter your mobile number</div>\n            </div>\n            \u2500\u2500 End mobile number login \u2500\u2500 -->\n\n            <!-- Password Field -->\n            <div class="lp__field item-input">\n              <label class="lp__label" for="password">\n                <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2.5"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>\n                Password\n              </label>\n              <div class="lp__input-row" style="position:relative;">\n                <input type="password" name="password" id="password"\n                  validate\n                  data-error-message="Enter your password"\n                  placeholder="Enter your password"\n                  minlength="6"\n                  required class="lp__password-input" style="padding-right:44px; padding-left:14px;" />\n                <button type="button" class="lp__eye-btn" id="togglePassword" tabindex="0" aria-label="Toggle password" style="position:absolute;right:8px;top:50%;transform:translateY(-50%);height:28px;width:36px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;">\n                  <i class="f7-icons" aria-hidden="true">eye</i>\n                </button>\n              </div>\n              <div class="item-input-error-message">Enter your password</div>\n            </div>\n\n            <!-- Forgot -->\n            <div class="lp__forgot-row">\n              <a href="#" class="lp__forgot popup-open" data-popup=".sheet-forget--pass">Forgot Password?</a>\n            </div>\n\n            <!-- Trust Badges -->\n            <div class="lp__trust-row">\n              <div class="lp__trust-badge">\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"><path d="M2 18h20l-3-7H5z"/><path d="M5 11l2-4h10l2 4"/></svg>\n                <span>XAUt Gold</span>\n              </div>\n              <div class="lp__trust-sep"></div>\n              <div class="lp__trust-badge">\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>\n                <span>0.60\u20132.0% Daily</span>\n              </div>\n              <div class="lp__trust-sep"></div>\n              <div class="lp__trust-badge">\n                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#C9A969" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>\n                <span>Global Access</span>\n              </div>\n            </div>\n\n            <!-- CTA -->\n            <button type="button" class="lp__btn-primary lgNum">\n              <span>Send OTP</span>\n              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>\n            </button>\n\n          </form>\n\n          <!-- OTP Continue -->\n          <button type="button" class="lp__btn-primary lp__btn-otp lgOTP hidden">\n            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>\n            <span>Verify &amp; Continue</span>\n          </button>\n          <a href="#" class="lp__resend resend-otp hidden">Resend OTP</a>\n\n          <!-- Divider -->\n          <div class="lp__divider">\n            <span></span>\n            <p>New to Digi Money Express?</p>\n            <span></span>\n          </div>\n\n          <!-- Register CTA -->\n          <a href="/register/referral/860F7321EF" class="lp__btn-secondary">\n            Open a Free Account\n          </a>\n        </div>\n      </div>\n\n      <!-- Footer -->\n      <footer class="lp__legal">\n        <p>By signing in you agree to our <a href="https://digitalmoneyexpress.com/terms-of-service/" target="_system" class="external link">Terms of Service</a> &amp; <a href="https://digitalmoneyexpress.com/privacy-policy/" target="_system" class="external link">Privacy Policy</a></p>\n        <p class="lp__legal-copy">&copy; ';
      r += c(ctx_1.year, ctx_1);
      r += ' Digi Money Express. All rights reserved.</p>\n      </footer>\n\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  style: `
/* ── Reset ── */
.lp *, .lp *::before, .lp *::after { box-sizing: border-box; margin: 0; padding: 0; }

/* ── Page ── */
.lp {
  background: #0f0f0f;
  position: relative;
  overflow: hidden;
}

.lp__content {
  background: transparent !important;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 44px 16px 36px;
  min-height: 100%;
  position: relative;
  z-index: 1;
}

/* ── Background layers ── */
.lp__bg-grid {
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(201,169,105,0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(201,169,105,0.05) 1px, transparent 1px);
  background-size: 44px 44px;
  pointer-events: none;
  z-index: 0;
}

.lp__bg-glow {
  position: fixed;
  top: -140px;
  left: 50%;
  transform: translateX(-50%);
  width: 560px;
  height: 560px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.13) 0%, transparent 62%);
  pointer-events: none;
  z-index: 0;
}

.lp__bg-glow2 {
  position: fixed;
  bottom: -100px;
  right: -80px;
  width: 320px;
  height: 320px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.05) 0%, transparent 65%);
  pointer-events: none;
  z-index: 0;
}

/* ── Brand Header ── */
.lp__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 400px;
  margin-bottom: 32px;
  position: relative;
}

.lp__logo-halo {
  position: absolute;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  width: 140px;
  height: 60px;
  background: radial-gradient(ellipse at center, rgba(201,169,105,0.22) 0%, transparent 70%);
  pointer-events: none;
  z-index: 0;
}

.lp__logo {
  position: relative;
  z-index: 1;
  width: 150px;
  height: 150px;
  object-fit: contain;
  margin-bottom: 14px;
  filter:
    drop-shadow(0 0 16px rgba(201,169,105,0.35))
    drop-shadow(0 4px 12px rgba(0,0,0,0.5));
}

.lp__brand-name {
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 3.5px;
  color: #FFFFFF;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.lp__brand-rule {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 160px;
  margin-bottom: 8px;
}

.lp__brand-rule span:not(.lp__brand-diamond) {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(201,169,105,0.5), transparent);
}

.lp__brand-diamond {
  font-size: 6px;
  color: #C9A969;
  opacity: 0.7;
}

.lp__brand-tag {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 2.8px;
  color: rgba(201,169,105,0.6);
  text-transform: uppercase;
}

/* ── Card ── */
.lp__card {
  width: 100%;
  max-width: 400px;
  background: linear-gradient(160deg, #1c1c1c 0%, #161616 100%);
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 20px;
  box-shadow:
    0 0 0 1px rgba(255,255,255,0.03),
    0 8px 32px rgba(0,0,0,0.5),
    0 32px 80px rgba(0,0,0,0.5),
    0 0 80px rgba(201,169,105,0.04);
}

.lp__card-accent {
  height: 2px;
  border-radius: 20px 20px 0 0;
  background: linear-gradient(90deg,
    transparent 0%,
    rgba(201,169,105,0.3) 15%,
    #C9A969 35%,
    #e8d08a 50%,
    #C9A969 65%,
    rgba(201,169,105,0.3) 85%,
    transparent 100%);
}

.lp__card-body {
  padding: 26px 22px 28px;
}

.lp__card-heading {
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.lp__title {
  font-size: 22px;
  font-weight: 800;
  letter-spacing: -0.3px;
  margin-bottom: 5px;
  background: linear-gradient(135deg, #ffffff 0%, #e8d4a8 60%, #C9A969 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.lp__subtitle {
  color: rgba(255,255,255,0.30);
  font-size: 12.5px;
  letter-spacing: 0.2px;
}

/* ── Fields ── */
.lp__field {
  margin-bottom: 10px;
}

.lp__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.38);
  margin-bottom: 8px;
}

/* ── Phone Row ── */
.lp__phone-row {
  background: #111111;
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  position: relative;
}

.lp__phone-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.08), inset 0 1px 0 rgba(201,169,105,0.04);
}

/* ── intl-tel-input scoped styles ── */
.lp .iti { width: 100%; display: block; }

.lp .iti__selected-flag {
  background: transparent !important;
  height: 52px;
  padding: 0 10px 0 12px;
  border-right: 1px solid rgba(201,169,105,0.12);
  border-radius: 12px 0 0 12px;
}

.lp .iti__selected-flag:hover,
.lp .iti__selected-flag:focus {
  background: rgba(201,169,105,0.05) !important;
}

.lp .iti__arrow {
  border-top-color: rgba(201,169,105,0.50);
  margin-left: 5px;
}

.lp .iti__arrow--up {
  border-bottom-color: rgba(201,169,105,0.50);
  border-top: none;
}

.lp .iti--separate-dial-code .iti__selected-dial-code,
.lp .iti--show-selected-dial-code .iti__selected-dial-code {
  color: #FFFFFF;
  font-size: 13px;
  margin-left: 5px;
}

/* ── iti dropdown (inline — sticks to input on scroll) ── */
.iti__country-list {
  background: #161616 !important;
  border: 1px solid rgba(201,169,105,0.22) !important;
  border-radius: 12px !important;
  box-shadow: 0 16px 48px rgba(0,0,0,0.85) !important;
  color: #ffffff !important;
  max-height: 260px !important;
  overflow-y: auto !important;
  z-index: 9999999 !important;
  margin-top: 4px !important;
}
/* Inline dropdown (login/register) spans the full input width.
   Direct child of .iti = inline; body-level (.iti--container) is unaffected. */
.iti > .iti__country-list {
  left: 0 !important;
  right: 0 !important;
  width: 100% !important;
}

.iti-mobile .iti--container {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  position: fixed !important;
  z-index: 9999999 !important;
  width: 90% !important;
}

.iti__country { padding: 9px 14px !important; }

.iti__country-name {
  color: rgba(255,255,255,0.82) !important;
  font-size: 13px !important;
}

.iti__dial-code {
  color: rgba(201,169,105,0.65) !important;
  font-size: 12px !important;
}

.iti__country.iti__highlight,
.iti__country:hover {
  background: rgba(201,169,105,0.09) !important;
}

.iti__divider {
  border-bottom-color: rgba(201,169,105,0.10) !important;
  margin: 4px 0 !important;
}

.iti__search-input {
  background: #1e1e1e !important;
  border: 1px solid rgba(201,169,105,0.18) !important;
  border-radius: 8px !important;
  color: #ffffff !important;
  font-size: 13px !important;
  margin: 7px !important;
  padding: 8px 12px !important;
  width: calc(100% - 14px) !important;
  box-sizing: border-box !important;
  outline: none !important;
}

.iti__search-input::placeholder { color: rgba(255,255,255,0.25) !important; }

.lp .lp__iti-input {
  height: 52px;
  background: transparent;
  border: none;
  color: #ffffff;
  font-size: 15px;
  outline: none;
  -webkit-user-select: text;
  user-select: text;
}

/* ── Generic Input ── */
.lp__input {
  display: block;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  padding: 0 14px;
  height: 52px;
  outline: none;
  font-weight: 400;
  -webkit-appearance: none;
  appearance: none;
  -webkit-user-select: text;
  user-select: text;
  flex: 1 1 auto;
  min-width: 0;
  width: auto;
}

.lp__input::placeholder { color: rgba(255,255,255,0.18); }

/* ── Password Row ── */
.lp__input-row {
  display: flex;
  align-items: center;
  width: 100%;
  background: #111111;
  border: 1px solid rgba(201,169,105,0.16);
  border-radius: 12px;
  transition: border-color 0.2s, box-shadow 0.2s;
  min-height: 52px;
}

.lp__input-row:focus-within {
  border-color: rgba(201,169,105,0.55);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.08), inset 0 1px 0 rgba(201,169,105,0.04);
}

.lp__password-input {
  flex: 1 1 auto;
  min-width: 0;
  height: 52px;
  background: transparent;
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  padding: 0 0 0 14px;
  outline: none;
  -webkit-appearance: none;
  appearance: none;
  -webkit-user-select: text;
  user-select: text;
}

.lp__password-input::placeholder { color: rgba(255,255,255,0.18); }

.lp__eye-btn {
  flex: 0 0 auto;
  background: transparent;
  border: none;
  color: rgba(201,169,105,0.45);
  padding: 0 14px;
  height: 52px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s;
}

.lp__eye-btn:active { color: #C9A969; }
.lp__eye-btn .f7-icons { font-size: 17px; }

/* ── Forgot ── */
.lp__forgot-row {
  display: flex;
  justify-content: flex-end;
  margin: 8px 0 18px;
}

.lp__forgot {
  font-size: 12px;
  font-weight: 600;
  color: rgba(201,169,105,0.65);
  text-decoration: none;
  letter-spacing: 0.2px;
}

/* ── Trust Badges ── */
.lp__trust-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0;
  margin-bottom: 20px;
  padding: 11px 10px;
  background: rgba(201,169,105,0.03);
  border: 1px solid rgba(201,169,105,0.09);
  border-radius: 10px;
}

.lp__trust-badge {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
}

.lp__trust-badge span {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.4px;
  color: rgba(201,169,105,0.60);
  text-transform: uppercase;
  text-align: center;
  white-space: nowrap;
}

.lp__trust-sep {
  width: 1px;
  height: 28px;
  background: rgba(201,169,105,0.12);
  flex-shrink: 0;
}

/* ── Primary Button ── */
@keyframes lp-shimmer {
  0%   { transform: translateX(-100%) skewX(-20deg); }
  100% { transform: translateX(220%) skewX(-20deg); }
}

.lp__btn-primary {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  height: 54px;
  border-radius: 12px;
  background: linear-gradient(135deg, #d4a84b 0%, #C9A969 40%, #a8853e 100%);
  color: #0f0f0f;
  font-size: 13.5px;
  font-weight: 900;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  border: none;
  cursor: pointer;
  text-decoration: none;
  box-shadow:
    inset 0 1px 0 rgba(255,255,255,0.20),
    inset 0 -1px 0 rgba(0,0,0,0.15),
    0 4px 16px rgba(201,169,105,0.30),
    0 8px 32px rgba(201,169,105,0.15);
  transition: transform 0.15s, box-shadow 0.18s;
}

.lp__btn-primary::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 45%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.22), transparent);
  animation: lp-shimmer 2.8s ease-in-out infinite;
  pointer-events: none;
}

.lp__btn-primary::after {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(255,255,255,0.10) 0%, transparent 50%);
  pointer-events: none;
}

.lp__btn-primary:active {
  transform: scale(0.982);
  box-shadow: 0 2px 8px rgba(201,169,105,0.20);
}

.lp__btn-otp { margin-top: 10px; }

/* ── Resend ── */
.lp__resend {
  display: block;
  text-align: center;
  color: rgba(201,169,105,0.60);
  font-size: 12.5px;
  font-weight: 600;
  margin-top: 14px;
  text-decoration: none;
  letter-spacing: 0.2px;
}

/* ── Divider ── */
.lp__divider {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 22px 0 14px;
}

.lp__divider span {
  flex: 1;
  height: 1px;
  background: rgba(255,255,255,0.06);
}

.lp__divider p {
  color: rgba(255,255,255,0.20);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  white-space: nowrap;
}

/* ── Secondary Button ── */
.lp__btn-secondary {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 50px;
  border-radius: 12px;
  background: transparent;
  border: 1px solid rgba(201,169,105,0.25);
  color: #C9A969;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-decoration: none;
  transition: background 0.18s, border-color 0.18s, box-shadow 0.18s;
}

.lp__btn-secondary:active {
  background: rgba(201,169,105,0.07);
  border-color: rgba(201,169,105,0.45);
  box-shadow: 0 0 0 3px rgba(201,169,105,0.06);
}

/* ── Legal Footer ── */
.lp__legal {
  margin-top: 24px;
  text-align: center;
  padding: 0 8px;
  width: 100%;
  max-width: 400px;
}

.lp__legal p {
  font-size: 10.5px;
  color: rgba(255,255,255,0.38);
  line-height: 1.65;
  margin-bottom: 3px;
}

.lp__legal a {
  color: rgba(201,169,105,0.40);
  text-decoration: none;
}

.lp__legal-copy {
  font-size: 9.5px !important;
  color: rgba(255,255,255,0.25) !important;
  letter-spacing: 0.3px;
}

/* ── Utility ── */
.hidden { display: none !important; }
`,
  styleScoped: false
};